import { useTranslation } from 'react-i18next';
import { Button } from '@components/ui/button';
import { ActionSheet } from '@components/scheduling/actionSheet';
import { ResourceList } from '../resourceList';
import { PhoneSwapSheetProps, SwapKind } from './types';

const labels: Record<SwapKind, { search: string; conflict: string }> = {
  field: {
    search: 'schedule.crew.searchPlaceholder',
    conflict: 'schedule.crew.tooltip.conflict.title',
  },
  crew: {
    search: 'schedule.crew.searchPlaceholder',
    conflict: 'schedule.crew.tooltip.conflict.title',
  },
  equipment: {
    search: 'schedule.equipment.searchPlaceholder',
    conflict: 'schedule.equipment.tooltip.conflict.title',
  },
};

export const PhoneSwapSheet = ({ target, options, onPick, onDismiss }: PhoneSwapSheetProps) => {
  const { t } = useTranslation('app');
  const kind = target?.kind || 'crew';

  return (
    <ActionSheet
      open={Boolean(target)}
      onDismiss={onDismiss}
      className="h-[85dvh]"
      title={t('scheduling.phone.replaceTitle', { name: target?.name || '' })}
      actions={
        <div className="!grid-cols-1">
          <Button variant="secondary" onClick={onDismiss}>
            {t(target?.fromConflicts ? 'scheduling.phone.goBack' : 'actions.cancel')}
          </Button>
        </div>
      }>
      <div className="flex min-h-full flex-col gap-1 pr-3">
        {target && (
          <ResourceList
            key={`${target.kind}-${target.id}`}
            single
            options={options}
            checked={[]}
            onPick={onPick}
            searchPlaceholder={t(labels[kind].search)}
            conflictTitle={t(labels[kind].conflict)}
            headerClassName="px-0"
          />
        )}
      </div>
    </ActionSheet>
  );
};
